import { Component, ElementRef, ViewChild, inject } from "@angular/core";
import { FormGroup, FormControl, Validators, FormArray } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import {
  WhatsappTemplateCreateRequestDTO,
  WhatsappTemplateDeleteRequestDTO,
  WhatsappTemplateReadAllMetaTemplatesRequestDTO,
} from "./whatsapp-template.interface";

import { WhatsappTemplateService } from "./whatsapp-template.service";
import { WhatsappConfigReadByIdRequestDTO } from "../whatsapp-config/whatsapp-config.interface";
import { UserLoginService } from "src/app/Common/UserLoginService/userlogin.service";
import { ConfirmmodalserviceService } from "src/app/Shared/confirm-delete-modal/confirmmodalservice.service";
import { WhatsappConfigService } from "../whatsapp-config/whatsapp-config.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationMaster_CreateRequestDTO } from "../history/history.interface";
import { HistoryService } from "../history/history.service";
import { ToastrService } from "ngx-toastr";


@Component({
  selector: "app-whatsapp-template",
  templateUrl: "./whatsapp-template.component.html",
  styleUrls: ["./whatsapp-template.component.css"],
})
export class WhatsappTemplateComponent {
  // FLAGS
  isLoading = false;
  totalCount = 0;
  detectedCategory = "UTILITY";
  placeholderError = "";
  selectedLanguage = "en_US";
  whatsappConfigList: any[] = [];
  whatsappTemplateList: any[] = [];
  selectedWaConfigId: number = 0;
  isTabSwitching = false;
toastr = inject(ToastrService);

@ViewChild('sendTestModal') sendTestModal!: ElementRef;

testPhoneNumber: string = '';
testValues: string = '';
selectedTestTemplate: any;




  // SERVICES
  User = inject(UserLoginService).User();
  private whatsappService = inject(WhatsappTemplateService);
  private confirmModal = inject(ConfirmmodalserviceService);
  private WhatsappConfigService = inject(WhatsappConfigService);
  private modalService = inject(NgbModal);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  historyService = inject(HistoryService);


  @ViewChild("whatsappTemplateModalForm") modalContent!: ElementRef;
  addwhatsappTemplateModalContent!: NgbModalRef;

  whatsappTemplateForm = new FormGroup({
    templateId: new FormControl(0),
    tName: new FormControl("", [Validators.required, Validators.pattern("^[a-z0-9_]+$")]),
    language: new FormControl("en_US", Validators.required),
    headerType: new FormControl("NONE"),
    otherDetail1: new FormControl(""),
    templateData: new FormControl("", Validators.required),
    tDesc: new FormControl(""),
    templateVariable: new FormControl(""),
    buttons: new FormArray([]),
    category: new FormControl("UTILITY"),
    templateCreatedDate: new FormControl(""),
    templateApprovedDate: new FormControl(""),
  });

  get buttons(): FormArray {
    return this.whatsappTemplateForm.get("buttons") as FormArray;
  }




  private createButtonRow(actionType: string) {
    let label = actionType;
    if (actionType === "QUICK_REPLY" || actionType === "Custom") label = "Custom";
    if (actionType === "URL" || actionType === "Visit Website") label = "Visit Website";
    if (actionType === "Call Support" || actionType === "Call Phone Number" || actionType === "Call") label = "Call Phone Number";

    return new FormGroup({
      actionType: new FormControl(label),
      buttonText: new FormControl(""),
      urlType: new FormControl("Static"),
      websiteUrl: new FormControl(""),
    });
  }

  addButton(actionType: string) {
    // Normalize inputs (openwhatsappTemplateForm used "QUICK_REPLY")
    if (actionType === "QUICK_REPLY" || actionType === "Custom") actionType = "Custom";
    if (actionType === "Visit Website" || actionType === "URL") actionType = "Visit Website";
    if (actionType === "Call Support" || actionType === "Call Phone Number" || actionType === "Call") actionType = "Call Phone Number";

    if (this.buttons.length >= 10) {
      this.placeholderError = "Maximum 10 buttons allowed.";
      setTimeout(() => (this.placeholderError = ""), 3000);
      return;
    }

    this.buttons.push(this.createButtonRow(actionType));
  }
  selectedTab: string = 'Grid';

  tabs = [
  {
    tabName: 'Tabular',
    tabIcon: 'bi bi-list',          
  },
  {
    tabName: 'Grid',
    tabIcon: 'bi bi-grid-fill',    
  }
];

  // onTabSelect(arg0: string) {
  //   // this.selectedTab = arg0
  //   // this.router.navigate([], {
  //   //   relativeTo: this.activatedRoute,
  //   //   queryParams: { view: this.selectedTab },
  //   //   queryParamsHandling: 'merge', // Keeps existing query params if needed
  //   //   replaceUrl: true              // Prevents extra history entry
  //   // });
  // }

  onTabSelect(tabName: string) {
    this.isTabSwitching = true;      // show loader
    this.selectedTab = tabName;

    setTimeout(() => {
      this.isTabSwitching = false;   // hide loader after short delay
    }, 400); // 400ms smooth switching
  }

   sendTestMessage(template: any) {

  
  // if (!this.testPhoneNumber) {
  //   this.confirmModal.openSwalModal(
  //     "",
  //     "Please enter phone number",
  //     "warning"
  //   );
  //   return;
  // }

  const data: NotificationMaster_CreateRequestDTO = {
    alertConfigId: Number(this.selectedWaConfigId),
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
    softwareId: 1,

   
    nType: 'Whatsapp',

    // The worker's Meta path reads "template:language" from the subject and the {{n}} values (pipe-separated) from the content.
    nSubject: template.name + ':' + template.language,
    nContent: this.testValues.trim(),
    nTo: this.testPhoneNumber,         

    nCc: "",
    nBcc: "",
    nStatus: "Pending",
    remarks: "",
    scheduledDate: new Date().toISOString(),
    attachmentPath: "",
    retryCount: 0,
    retryDate: null,
    postSendDataSourceType: "",
    postSendDataSourceDef: "",
    dbConnId: 1,
    actionUser: this.User.userId.toString()
  };

  this.historyService.notificationMaster_Create(data).subscribe({
    next: () => {
      this.confirmModal.openSwalModal(
        "",
        "Test WhatsApp message has been queued successfully.",
        "success"
      );

      
      this.testPhoneNumber = "";
      this.testValues = "";
    },
    error: () => {
      this.confirmModal.openSwalModal(
        "",
        "Failed to queue WhatsApp test message.",
        "error"
      );
    }
  });
}


// sendTestMessage() {
//   if (!this.testPhoneNumber) {
//     alert('Please enter phone number');
//     return;
//   }

//   console.log('SEND TEST:', {
//     templateName: this.selectedTestTemplate?.name,
//     phoneNo: this.testPhoneNumber,
//     waConfigId: this.selectedWaConfigId
//   });

//   // ✅ Later this is where test-send API will go

//   this.modalService.dismissAll();
// }



  deleteButton(index: number) {
    this.buttons.removeAt(index);
  }

  toggleDropdown(event: any) {
    event.stopPropagation();
    this.closeAllDropdowns();
    const el = event.currentTarget as HTMLElement;
    // we toggle parent .wt-dropdown so structure in HTML works as intended
    el.parentElement?.classList.toggle("open");
  }

  closeAllDropdowns() {
    document.querySelectorAll(".wt-dropdown.open").forEach((el) => {
      el.classList.remove("open");
    });
  }


 loadWhatsappConfigs() {
  this.WhatsappConfigService.WhatsAppConfig_readAll().subscribe({
    next: (res: any) => {
      this.whatsappConfigList = res?.items ?? [];

     
      if (this.whatsappConfigList.length) {

        // Find AdvinERP explicitly
        const advinConfig = this.whatsappConfigList.find(
          c => c.iName === 'AdvinERP'
        );

        if (advinConfig && !this.selectedWaConfigId) {
          this.selectedWaConfigId = advinConfig.waConfigId;
          this.loadMetaTemplatesList(); // load templates immediately
        }
      }
    },
    error: (err) => {
      console.error('Failed to load whatsapp config list', err);
    }
  });
}



  
  onWhatsappConfigChange(waConfigId: number) {

    this.selectedWaConfigId = waConfigId;

    if (!waConfigId) {
      this.whatsappTemplateList = [];
      return;
    }

    // Update URL (so refresh works). The page is routed from /notification/whatsapptemplate and /marketing/whatsapp/template,
    // so keep whichever base the user came in on.
    const base = this.router.url.split('?')[0].replace(/\/\d+$/, '');
    history.replaceState(null, '', `${base}/${waConfigId}`);

    // Reload templates for selected config
    this.loadMetaTemplatesList();
  }


  openwhatsappTemplateForm() {
    if (!this.selectedWaConfigId || this.selectedWaConfigId === 0) {
    this.toastr.warning("Please select WhatsApp Config first")
    }
    this.whatsappTemplateForm.reset({
      templateId: 0,
      language: "en_US",
      headerType: "NONE",
      category: "UTILITY",
    });

    this.selectedLanguage = "en_US";
    this.detectedCategory = "UTILITY";
    this.placeholderError = "";
    this.whatsappTemplateForm.get("templateVariable")?.setValue("");

    this.buttons.clear();
    this.addButton("QUICK_REPLY");
    this.addwhatsappTemplateModalContent = this.modalService.open(this.modalContent, { size: "xl" });
  }

  onBodyInput() {
    const body = (this.whatsappTemplateForm.get("templateData")?.value || "").toString();
    const placeholderPattern = /\{\{(\d+)\}\}/g;
    const found = Array.from(body.matchAll(placeholderPattern), (m) => m[1]);

    if ((body.includes("{{") || body.includes("}}")) && found.length === 0) {
      this.placeholderError = "Invalid placeholder format. Use {{1}}, {{2}}, ... with numbers only.";
    } else {
      this.placeholderError = "";
    }

    this.autoFillTemplateVariables();
    this.detectCategory(body);
    this.whatsappTemplateForm.get("category")?.setValue(this.detectedCategory);
  }

  detectCategory(body: string) {
    const content = (body || "").toLowerCase();

    if (content.includes("otp") || content.includes("one-time") || content.includes("verification") || content.includes("code")) {
      this.detectedCategory = "AUTHENTICATION";
    } else if (
      content.includes("order") ||
      content.includes("payment") ||
      content.includes("delivery") ||
      content.includes("invoice") ||
      content.includes("booking")
    ) {
      this.detectedCategory = "UTILITY";
    } else {
      this.detectedCategory = "MARKETING";
    }
  }

  selectLanguage(code: string) {
    this.selectedLanguage = code;
    this.whatsappTemplateForm.patchValue({ language: code });
    this.closeAllDropdowns();
  }

  autoFillTemplateVariables() {
    const body = (this.whatsappTemplateForm.get("templateData")?.value || "").toString();
    const placeholderPattern = /\{\{(\d+)\}\}/g;

    const matches = Array.from(body.matchAll(placeholderPattern)).map((m) => `{{${m[1]}}}`);

    if (matches.length > 0) {
      const uniqueVars = Array.from(new Set(matches)); // remove duplicates
      this.whatsappTemplateForm.get("templateVariable")?.setValue(uniqueVars.join(", "));
    } else {
      this.whatsappTemplateForm.get("templateVariable")?.setValue("");
    }
  }

  isUrlButton(btn: any) {
    return (btn.get("actionType")?.value || "") === "Visit Website";
  }

  isCallButton(btn: any) {
    return (btn.get("actionType")?.value || "") === "Call Phone Number";
  }

  isQuickReply(btn: any) {
    const v = (btn.get("actionType")?.value || "").toString();
    return v === "Custom" || v === "QUICK_REPLY";
  }


  validateButton(btn: any): boolean {
    const type = (btn.get("actionType")?.value || "").toString();
    const urlCtrl = btn.get("websiteUrl");
    const url = (urlCtrl?.value || "").toString();
    // clear previous errors
    urlCtrl?.setErrors(null);
    if (type === "Custom" || type === "QUICK_REPLY") {
      return true;
    }
    if (type === "Call Phone Number") {
      const phoneRegex = /^tel:\+\d{10,15}$/;
      if (!phoneRegex.test(url || "")) {
        urlCtrl?.setErrors({ invalidPhone: { message: "Phone number must be in format: tel:+91XXXXXXXXXX" } });
        urlCtrl?.markAsTouched();
        return false;
      }
      return true;
    }
    if (type === "Visit Website") {
      if (!url) {
        urlCtrl?.setErrors({ required: true });
        urlCtrl?.markAsTouched();
        return false;
      }
      const websiteRegex = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
      if (!websiteRegex.test(url || "")) {
        urlCtrl?.setErrors({ invalidUrl: "Enter a valid URL (must start with http:// or https://)" });
        urlCtrl?.markAsTouched();
        return false;
      }
      return true;
    }

    return true;
  }

  submitwhatsappTemplateForm() {
    
    // mark form touched
    this.whatsappTemplateForm.markAllAsTouched();
    // Validate each button first (stop submission if any invalid)
    for (let i = 0; i < this.buttons.length; i++) {
      const btn = this.buttons.at(i);
      if (!this.validateButton(btn)) {
        // keep focus on form — stop submitting
        return;
      }
    }

    if (!this.whatsappTemplateForm.valid) {
      return;
    }

    const f = this.whatsappTemplateForm.value;

    const componentsAny: any[] = [
      {
        type: "HEADER",
        format: f.headerType && f.headerType !== "NONE" ? f.headerType : "TEXT",
        text: f.otherDetail1 ?? "",
      },
      {
        type: "BODY",
        text: f.templateData ?? "",
      },
      {
        type: "FOOTER",
        text: f.tDesc ?? "",
      },
    ];
    
    const buttonsPayload = (f.buttons || []).map((b: any) => {
      // map UI label actionType to payload type
      let btnTypeLabel = (b.actionType || "").toString();
      let payloadType = "QUICK_REPLY";
      if (btnTypeLabel === "Custom" || btnTypeLabel === "QUICK_REPLY") {
        payloadType = "QUICK_REPLY";
      } else if (btnTypeLabel === "Visit Website") {
        payloadType = "URL";
      } else if (btnTypeLabel === "Call Phone Number") {
        payloadType = "URL";
      } else {
        // fallback
        payloadType = btnTypeLabel === "URL" ? "URL" : "QUICK_REPLY";
      }

      let urlValue = b.websiteUrl || "";

      // no aggressive modification — but ensure tel: link remains if call type
      if (btnTypeLabel === "Call Phone Number" && urlValue && !/^tel:/i.test(urlValue)) {
        // if user entered plain number, do not auto-change here (we validate), but you might choose to auto-prefix
        // leave as-is; validation will fail unless it's tel:+...
      }

      return {
        type: payloadType === "QUICK_REPLY" ? "QUICK_REPLY" : "URL",
        text: b.buttonText || "",
        url: urlValue || "",
      };
    });
    
    const payload: WhatsappTemplateCreateRequestDTO = {
      waConfigId: this.selectedWaConfigId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      name: (f.tName ? f.tName.toString().toLowerCase().replace(/\s+/g, "_") : "template"),
      category: f.category || this.detectedCategory || "UTILITY",
      language: f.language || this.selectedLanguage || "en_US",
      components: componentsAny as any,
      buttons: buttonsPayload,
    };
    
    this.whatsappService.whatsappTemplate_Create(payload).subscribe({
      next: () => {
        this.addwhatsappTemplateModalContent.close();
        this.loadMetaTemplatesList();
      },
      error: (err) => {
        console.error("Create failed", err);
      },
    });
  }

  loadMetaTemplatesList() {
    this.isLoading = true;

    const req: WhatsappTemplateReadAllMetaTemplatesRequestDTO = {
      waConfigId: this.selectedWaConfigId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    };


    this.whatsappService.whatsappTemplate_ReadAllMetaTemplates(req).subscribe({
      next: (res) => {
        this.whatsappTemplateList = res?.items ?? [];
        this.totalCount = this.whatsappTemplateList.length;
        this.isLoading = false;
      },
      error: () => (this.isLoading = false),
    });
  }

  handleActionClick(event: { actionName: string; rowData: any }) {
    if (event.actionName === "Edit") this.editTemplate(event.rowData);
    if (event.actionName === "Delete") this.deleteTemplate(event.rowData);
  }

  editTemplate(row: any) {
    this.whatsappTemplateForm.patchValue({
      templateId: row?.waConfigId ?? this.selectedWaConfigId,

      tName: row?.name ?? "",
      language: row?.language ?? "en_US",
      headerType: "TEXT",
      otherDetail1: row?.components?.find((c: any) => c.type === "HEADER")?.text ?? "",
      templateData: row?.components?.find((c: any) => c.type === "BODY")?.text ?? "",
      tDesc: row?.components?.find((c: any) => c.type === "FOOTER")?.text ?? "",
      category: row?.category ?? this.detectedCategory,
    });

    this.autoFillTemplateVariables();

    this.buttons.clear();
    const remoteButtons = row?.buttons || [];
    if (remoteButtons.length) {
      remoteButtons.forEach((rb: any) => {
        // rb.type is usually "URL" or "QUICK_REPLY"
        // determine correct UI label: Visit Website / Call Phone Number / Custom
        let typeLabel = "Custom";
        if (rb.type === "URL") {
          const url = (rb.url || "").toString();
          if (url.startsWith("tel:")) {
            typeLabel = "Call Phone Number";
          } else {
            typeLabel = "Visit Website";
          }
        } else if (rb.type === "QUICK_REPLY") {
          typeLabel = "Custom";
        }
        const g = this.createButtonRow(typeLabel);
        g.patchValue({
          buttonText: rb.text || "",
          websiteUrl: rb.url || "",
          urlType: "Static",
        });
        this.buttons.push(g);
      });
    } else {
      this.addButton("QUICK_REPLY");
    }

    this.addwhatsappTemplateModalContent = this.modalService.open(this.modalContent, { size: "xl" });
  }

  deleteTemplate(row: any) {
    this.confirmModal.openDeleteModal(row.name ?? "Template", row).subscribe((res) => {
      if (res) {
        const req: WhatsappTemplateDeleteRequestDTO = {
          waConfigId: this.selectedWaConfigId,
          tenantId: this.User.companyId,
          tenantBranchId: this.User.loggedInBranchId
          , // Always use 20
          templateName: row.name ?? "", // Meta template name
        };
        console.log("DELETE REQ:", req);

        this.whatsappService.whatsappTemplate_Delete(req).subscribe({
          next: () => this.loadMetaTemplatesList(),
          error: (err) => console.error("Delete failed", err),
        });
      }
    });

  }


  ngOnInit() {
    document.addEventListener("click", () => this.closeAllDropdowns());

    // ✅ ADD: Load dropdown data
    this.loadWhatsappConfigs();

    this.selectedWaConfigId = Number(this.route.snapshot.paramMap.get('waConfigId'));
    console.log("CONFIG ID:", this.selectedWaConfigId);

    // ✅ ADD: Load templates only if config exists
    if (this.selectedWaConfigId) {
      this.loadMetaTemplatesList();
    }

    this.whatsappTemplateForm.get("templateData")?.valueChanges.subscribe((val) => {
      this.detectCategory(val || "");
      this.autoFillTemplateVariables();
    });
  }


  getBodyText(template: any): string {
    const body = template?.components?.find((c: any) => c.type === "BODY");
    return body?.text || "";
  }
  formatBodyText(body: string): string {
    if (!body) return "";

    let formatted = body;

    // Replace {{1}} / {{2}} → (text)
    formatted = formatted.replace(/\{\{\d+\}\}/g, `<span style="color:#397300">(text)</span>`);

    // Replace {{text}} → (text)
    formatted = formatted.replace(/\{\{.*?\}\}/g, `<span style="color:#397300">(text)</span>`);

    // Replace *(text)* → (text)
    formatted = formatted.replace(/\*\(text\)\*/g, `<span style="color:#397300">(text)</span>`);

    // Replace plain (text)
    formatted = formatted.replace(/\(text\)/g, `<span style="color:#397300">(text)</span>`);

    return formatted;
  }


  // getTemplateTime(template: any): string {
  //   const time = template?.templateApprovedDate || template?.templateCreatedDate;
  //   return time ? new Date(time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "";
  // }


}
